/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiMultipleResult,
    ApiResult,
    DeviceGroupDto,
    DeviceGroupMapDevicesRequest,
    DeviceGroupMapRfidTagsRequest,
    DeviceGroupMapUserAccountsRequest,
    DeviceGroupUptimeResponse,
    UpdateDeviceGroupContactsRequest,
} from "../models/index";
import {
    ApiMultipleResultFromJSON,
    ApiMultipleResultToJSON,
    ApiResultFromJSON,
    ApiResultToJSON,
    DeviceGroupDtoFromJSON,
    DeviceGroupDtoToJSON,
    DeviceGroupMapDevicesRequestFromJSON,
    DeviceGroupMapDevicesRequestToJSON,
    DeviceGroupMapRfidTagsRequestFromJSON,
    DeviceGroupMapRfidTagsRequestToJSON,
    DeviceGroupMapUserAccountsRequestFromJSON,
    DeviceGroupMapUserAccountsRequestToJSON,
    DeviceGroupUptimeResponseFromJSON,
    DeviceGroupUptimeResponseToJSON,
    UpdateDeviceGroupContactsRequestFromJSON,
    UpdateDeviceGroupContactsRequestToJSON,
} from "../models/index";

export interface DeviceGroupContactUpdateRequest {
    deviceGroupTag: string;
    body?: UpdateDeviceGroupContactsRequest;
}

export interface DeviceGroupDailyUptimesRequest {
    deviceGroupTag: string;
    serviceModelDeviceGroupTag?: string;
    from?: string;
    to?: string;
}

export interface DeviceGroupDeleteRequest {
    deviceGroupTag: string;
    validateOnly?: boolean;
}

export interface DeviceGroupDetailRequest {
    deviceGroupTag: string;
}

export interface DeviceGroupMapDevicesOperationRequest {
    deviceGroupTag: string;
    body?: DeviceGroupMapDevicesRequest;
}

export interface DeviceGroupMapRfidTagsOperationRequest {
    deviceGroupTag: string;
    body?: DeviceGroupMapRfidTagsRequest;
}

export interface DeviceGroupMapUserAccountsOperationRequest {
    deviceGroupTag: string;
    body?: DeviceGroupMapUserAccountsRequest;
}

export interface DeviceGroupUpdateRequest {
    body?: DeviceGroupDto;
}

export interface DeviceGroupUptimeRequest {
    deviceGroupTag: string;
    serviceModelDeviceGroupTag?: string;
    from?: string;
    to?: string;
}

export interface ToggleFavouriteDeviceGroupRequest {
    deviceGroupTag: string;
    isFavourite: boolean;
}

/**
 *
 */
export class DeviceGroupHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Update device group contacts. The new contacts will replace the old contacts of the device group.
     */
    async deviceGroupContactUpdateRaw(
        requestParameters: DeviceGroupContactUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceGroupContactUpdate().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}/contacts`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: UpdateDeviceGroupContactsRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update device group contacts. The new contacts will replace the old contacts of the device group.
     */
    async deviceGroupContactUpdate(
        requestParameters: DeviceGroupContactUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceGroupContactUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get various daily uptime metrics for device groups with type of Site or Organisation. Will default to last 30 days if date range not specified.
     */
    async deviceGroupDailyUptimesRaw(
        requestParameters: DeviceGroupDailyUptimesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceGroupUptimeResponse>>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceGroupDailyUptimes().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["serviceModelDeviceGroupTag"] != null) {
            queryParameters["serviceModelDeviceGroupTag"] =
                requestParameters["serviceModelDeviceGroupTag"];
        }

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}/uptime-daily`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceGroupUptimeResponseFromJSON),
        );
    }

    /**
     * Get various daily uptime metrics for device groups with type of Site or Organisation. Will default to last 30 days if date range not specified.
     */
    async deviceGroupDailyUptimes(
        requestParameters: DeviceGroupDailyUptimesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceGroupUptimeResponse>> {
        const response = await this.deviceGroupDailyUptimesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete device group. Group must have no devices, rfid tags, or user accounts assigned before it can be deleted.
     */
    async deviceGroupDeleteRaw(
        requestParameters: DeviceGroupDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiMultipleResult>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceGroupDelete().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["validateOnly"] != null) {
            queryParameters["validateOnly"] = requestParameters["validateOnly"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiMultipleResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete device group. Group must have no devices, rfid tags, or user accounts assigned before it can be deleted.
     */
    async deviceGroupDelete(
        requestParameters: DeviceGroupDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiMultipleResult> {
        const response = await this.deviceGroupDeleteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Device group details
     */
    async deviceGroupDetailRaw(
        requestParameters: DeviceGroupDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceGroupDto>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceGroupDetail().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceGroupDtoFromJSON(jsonValue),
        );
    }

    /**
     * Device group details
     */
    async deviceGroupDetail(
        requestParameters: DeviceGroupDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceGroupDto> {
        const response = await this.deviceGroupDetailRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Add or remove devices from groups.
     */
    async deviceGroupMapDevicesRaw(
        requestParameters: DeviceGroupMapDevicesOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiMultipleResult>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceGroupMapDevices().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}/devices`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceGroupMapDevicesRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiMultipleResultFromJSON(jsonValue),
        );
    }

    /**
     * Add or remove devices from groups.
     */
    async deviceGroupMapDevices(
        requestParameters: DeviceGroupMapDevicesOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiMultipleResult> {
        const response = await this.deviceGroupMapDevicesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Add or remove RfidTags from groups. Only RfidTags with Rule=DeviceGroups may be mapped. See also: SetRfidTagDeviceGroups
     */
    async deviceGroupMapRfidTagsRaw(
        requestParameters: DeviceGroupMapRfidTagsOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiMultipleResult>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceGroupMapRfidTags().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}/rfidtags`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceGroupMapRfidTagsRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiMultipleResultFromJSON(jsonValue),
        );
    }

    /**
     * Add or remove RfidTags from groups. Only RfidTags with Rule=DeviceGroups may be mapped. See also: SetRfidTagDeviceGroups
     */
    async deviceGroupMapRfidTags(
        requestParameters: DeviceGroupMapRfidTagsOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiMultipleResult> {
        const response = await this.deviceGroupMapRfidTagsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Add or remove user accounts from groups, for access control. Currently only EnterpriseUser and Driver account types may be mapped. See also: SetUserAccountDeviceGroups
     */
    async deviceGroupMapUserAccountsRaw(
        requestParameters: DeviceGroupMapUserAccountsOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiMultipleResult>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceGroupMapUserAccounts().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}/user-accounts`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceGroupMapUserAccountsRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiMultipleResultFromJSON(jsonValue),
        );
    }

    /**
     * Add or remove user accounts from groups, for access control. Currently only EnterpriseUser and Driver account types may be mapped. See also: SetUserAccountDeviceGroups
     */
    async deviceGroupMapUserAccounts(
        requestParameters: DeviceGroupMapUserAccountsOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiMultipleResult> {
        const response = await this.deviceGroupMapUserAccountsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Insert/Update device group. Use null DeviceGroupTag when inserting. Does not update the user/device/rfidTag mappings.
     */
    async deviceGroupUpdateRaw(
        requestParameters: DeviceGroupUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceGroupDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Insert/Update device group. Use null DeviceGroupTag when inserting. Does not update the user/device/rfidTag mappings.
     */
    async deviceGroupUpdate(
        requestParameters: DeviceGroupUpdateRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceGroupUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get various uptime metrics for device groups with type of Site or Organisation (or ServiceModel). Will default to last 30 days if date range not specified.
     */
    async deviceGroupUptimeRaw(
        requestParameters: DeviceGroupUptimeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceGroupUptimeResponse>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceGroupUptime().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["serviceModelDeviceGroupTag"] != null) {
            queryParameters["serviceModelDeviceGroupTag"] =
                requestParameters["serviceModelDeviceGroupTag"];
        }

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}/uptime`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceGroupUptimeResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get various uptime metrics for device groups with type of Site or Organisation (or ServiceModel). Will default to last 30 days if date range not specified.
     */
    async deviceGroupUptime(
        requestParameters: DeviceGroupUptimeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceGroupUptimeResponse> {
        const response = await this.deviceGroupUptimeRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * An OData endpoint that lists device groups visible for the current IlluminateUser. Pass an \'orgSearch\' OData filter parameter to search organisation device groups by organisation name/id, also returning the children of any matched organisation; eg $filter=contains(tolower(orgSearch),\'acme\').
     */
    async deviceGroupsODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceGroupDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceGroupDtoFromJSON),
        );
    }

    /**
     * An OData endpoint that lists device groups visible for the current IlluminateUser. Pass an \'orgSearch\' OData filter parameter to search organisation device groups by organisation name/id, also returning the children of any matched organisation; eg $filter=contains(tolower(orgSearch),\'acme\').
     */
    async deviceGroupsOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceGroupDto>> {
        const response = await this.deviceGroupsODataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Toggle favourite device group for the current IlluminateUser.
     */
    async toggleFavouriteDeviceGroupRaw(
        requestParameters: ToggleFavouriteDeviceGroupRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling toggleFavouriteDeviceGroup().',
            );
        }

        if (requestParameters["isFavourite"] == null) {
            throw new runtime.RequiredError(
                "isFavourite",
                'Required parameter "isFavourite" was null or undefined when calling toggleFavouriteDeviceGroup().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["isFavourite"] != null) {
            queryParameters["isFavourite"] = requestParameters["isFavourite"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}/favourite`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "PATCH",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Toggle favourite device group for the current IlluminateUser.
     */
    async toggleFavouriteDeviceGroup(
        requestParameters: ToggleFavouriteDeviceGroupRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.toggleFavouriteDeviceGroupRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
